import type { Language } from "@app/constants";

interface Messages {
	linkSuccess: string;
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		linkSuccess: "Kraken Account Linked Successfully",
	},
};

export default messages;
